import { Card, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import React from "react";
import clsx from "clsx";

type NoDataProps = {
  className?: string;
  fullScreen?: boolean;
  title?: string;
  message?: string;
  icon?: React.ReactNode;
};

const NoData: React.FC<NoDataProps> = ({
  className = "",
  fullScreen = false,
  title = "No data available",
  message = "There’s nothing here to display.",
  icon,
}) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-center",
        fullScreen ? "h-screen" : "h-full",
        className,
      )}
    >
      <Card className="p-8 rounded-2xl shadow-lg text-center">
        <div className="flex flex-col items-center">
          {icon || (
            <InboxOutlined
              style={{ color: "#8c8c8c" }}
              className="text-4xl mb-2"
            />
          )}
          <Typography.Title level={4} className="mb-2">
            {title}
          </Typography.Title>
          <Typography.Text type="secondary">{message}</Typography.Text>
        </div>
      </Card>
    </div>
  );
};

export default NoData;
